var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSugarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Left-images",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Back-box",
    width: 74,
    height: 74,
    rx: 8,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "glucosemeter",
    transform: "translate(10 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    transform: "translate(13.427 41.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M146.568,357.339v14.109a2.265,2.265,0,0,1-2.264,2.257h-5.976a2.266,2.266,0,0,1-2.262-2.257V357.339C139.972,354.449,143.6,354.93,146.568,357.339Z",
    transform: "translate(-136.066 -355.348)",
    fill: "#f9f7f8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M34.916,43.634A18.678,18.678,0,0,0,58.844,25.752V7.564A7.593,7.593,0,0,0,51.263,0H29.07a7.593,7.593,0,0,0-7.581,7.564V25.752A18.717,18.717,0,0,0,34.916,43.634Z",
    transform: "translate(-21.489 0)",
    fill: "#375e7d",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789",
    transform: "translate(15.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M166.207,7.279V19.5a1.511,1.511,0,0,1-1.347,1.495v4.76c0,.32-.007.639-.024.955a2.564,2.564,0,0,1,.582,2.8,12.615,12.615,0,0,1-2.439,4.372,18.815,18.815,0,0,1-13.161,10.156,18.685,18.685,0,0,0,22.317-18.28V7.564A7.593,7.593,0,0,0,164.553,0h-7.275a7.613,7.613,0,0,1,7.368,5.777h.052a1.51,1.51,0,0,1,1.509,1.5Z",
    transform: "translate(-149.818 0)",
    fill: "#2b4d66",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790",
    transform: "translate(5.928 5.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M73.583,64.522H96.065a1.508,1.508,0,0,0,1.509-1.5V50.8a1.51,1.51,0,0,0-1.509-1.5H73.583a1.51,1.51,0,0,0-1.509,1.5V63.02A1.508,1.508,0,0,0,73.583,64.522Z",
    transform: "translate(-72.074 -49.3)",
    fill: "#b1e4f9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791",
    transform: "translate(12.521 9.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M129.241,85.839a.905.905,0,0,1-.558-1.619l7.189-5.619a.905.905,0,1,1,1.115,1.427L129.8,85.647A.9.9,0,0,1,129.241,85.839Z",
    transform: "translate(-128.335 -78.409)",
    fill: "#75cef8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792",
    transform: "translate(18.084 12.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M176.711,113.529a.905.905,0,0,1-.558-1.619l3.593-2.808a.905.905,0,1,1,1.115,1.427l-3.593,2.808A.9.9,0,0,1,176.711,113.529Z",
    transform: "translate(-175.805 -108.91)",
    fill: "#75cef8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793",
    transform: "translate(25.875 5.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M243.793,50.8V63.02a1.507,1.507,0,0,1-1.505,1.5h4.044a1.508,1.508,0,0,0,1.509-1.5V50.8a1.51,1.51,0,0,0-1.509-1.5h-4.044A1.509,1.509,0,0,1,243.793,50.8Z",
    transform: "translate(-242.288 -49.3)",
    fill: "#75cef8",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794",
    transform: "translate(18.68 26.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M192.849,227a12.6,12.6,0,0,1-11.054,8.734c-.3.022-.6-.108-.905-.108v-11.71l.905-.2h9.039C192.518,223.715,193.407,225.237,192.849,227Z",
    transform: "translate(-180.89 -223.715)",
    fill: "#a7e9a6",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(6.552 26.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M89.527,223.919v11.7c-.3,0-.606.141-.905.12A12.593,12.593,0,0,1,77.567,227c-.561-1.766.331-3.289,2.012-3.289h9.042Z",
    transform: "translate(-77.399 -223.715)",
    fill: "#eb5468",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796",
    transform: "translate(17.774 26.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M174.975,223.714v12.023q-.449.033-.905.033t-.905-.033V223.714Z",
    transform: "translate(-173.164 -223.714)",
    fill: "#2b4d66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797",
    transform: "translate(21.863 29.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M208.955,252.78a.905.905,0,0,1-.628-1.558l.907-.873-.906-.87a.905.905,0,0,1,1.255-1.306l1.585,1.523a.905.905,0,0,1,0,1.3l-1.585,1.526A.9.9,0,0,1,208.955,252.78Z",
    transform: "translate(-208.05 -247.92)",
    fill: "#f9f7f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798",
    transform: "translate(12.097 29.053)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M127.211,252.781a.9.9,0,0,1-.628-.253L125,251a.905.905,0,0,1,0-1.3l1.584-1.522a.905.905,0,1,1,1.255,1.306l-.906.87.907.873a.905.905,0,0,1-.628,1.557Z",
    transform: "translate(-124.721 -247.922)",
    fill: "#f9f7f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    transform: "translate(22.482 26.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M216.29,223.71c1.681,0,2.573,1.76,2.011,3.8a14.567,14.567,0,0,1-4.967,7.664A12.642,12.642,0,0,0,221.492,227c.558-1.766-.331-3.289-2.015-3.289Z",
    transform: "translate(-213.335 -223.71)",
    fill: "#7fdbae",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800",
    transform: "translate(18.679 43.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M183.15,372.961v13.49a2.266,2.266,0,0,1-2.263,2.258h2.986a2.264,2.264,0,0,0,2.263-2.258V372.342A18.618,18.618,0,0,1,183.15,372.961Z",
    transform: "translate(-180.887 -372.342)",
    fill: "#dddaec",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_801",
    "data-name": "Group 801",
    transform: "translate(34.793 31.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M327.652,268.541c-2.735,4.1-9.266,12.95-9.266,18.019,0,6.578,5.043,9.867,10.085,9.867s10.085-3.289,10.085-9.867c0-5.069-6.531-13.919-9.266-18.019C328.644,267.569,328.3,267.569,327.652,268.541Z",
    transform: "translate(-318.386 -267.812)",
    fill: "#eb5468",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802",
    transform: "translate(36.632 31.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M345.452,282.748a10.389,10.389,0,0,1-.985,4.571,9.884,9.884,0,0,1-9.1,5.3,11.458,11.458,0,0,1-1.285-.072,10.174,10.174,0,0,0,8.246,3.884c4.616,0,9.231-2.756,9.979-8.266a11.989,11.989,0,0,0,.107-1.6c0-5.069-6.531-13.919-9.265-18.019-.648-.973-.992-.973-1.64,0-.4.591-.868,1.282-1.388,2.045C342.766,274.7,345.452,279.5,345.452,282.748Z",
    transform: "translate(-334.082 -267.811)",
    fill: "#e5384f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803",
    transform: "translate(17.774 55.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M174.974,470.864v4.021h-1.811v-4.021a.905.905,0,1,1,1.811,0Z",
    transform: "translate(-173.163 -469.959)",
    fill: "#dddaec"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarIcon);
export default __webpack_public_path__ + "static/media/sugar-icon.1a7e82b96fd08bd342503ea10b14be32.svg";
export { ForwardRef as ReactComponent };